module.exports = __webpack_public_path__ + "static/media/andrew.798f84ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/andrew.jpg
// module id = 91
// module chunks = 0